import React, { useRef, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, LinearProgress } from "@mui/material";

interface SingleFileUploadDialogProps {
  open: boolean;
  onClose: () => void;
  onUpload: (formData: FormData) => Promise<void>; 
}

const SingleFileUploadDialog: React.FC<SingleFileUploadDialogProps> = ({ open, onClose, onUpload }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
//   const [progress, setProgress] = useState(0);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) return;
    setUploading(true);
    const formData = new FormData();
    formData.append("file", selectedFile, selectedFile.name);

    // Optionally, you can add more fields to formData here

    try {
      await onUpload(formData);
      setSelectedFile(null);
      // onClose();
    } finally {
      setUploading(false);
    //   setProgress(0);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>Upload Configuration File</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
            <Button
            variant="contained"
            component="label"
            disabled={uploading}
            >
            Choose File
            <input
              type="file"
              hidden
              ref={inputRef}
              onChange={handleFileChange}
              accept=".xml,.txt,.csv"
            />
            </Button>
          {selectedFile && (
            <Typography variant="body2">{selectedFile.name}</Typography>
          )}
          {uploading && <LinearProgress variant="indeterminate" sx={{ width: "100%" }} />}
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Button  variant="outlined" onClick={onClose} disabled={uploading}>Cancel</Button>
        <Button
          onClick={handleUpload}
          disabled={!selectedFile || uploading}
          variant="contained"
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SingleFileUploadDialog;